import { render, staticRenderFns } from "./indexCenter.vue?vue&type=template&id=28b9f4ae&scoped=true&"
import script from "./indexCenter.vue?vue&type=script&lang=js&"
export * from "./indexCenter.vue?vue&type=script&lang=js&"
import style0 from "./indexCenter.vue?vue&type=style&index=0&id=28b9f4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9f4ae",
  null
  
)

export default component.exports